import React, { Component } from 'react';
import './css/nav.css';
import './css/font-awesome.css';
import './css/fontastic.css';
import axios from 'axios';
import Navigation from './Navigation';
import Page from './overview/Page';

import { withRouter } from 'react-router-dom';
export class Dashboard extends Component {

    constructor(props) {
        super(props);
            this.state={
                datos:[ {
                    "nombresitio": [
                        {
                            "_id": "5de824204294d440aed85602",
                            "nombre": "Actualizando"
                        }
                    ]
                },
                {
                    "lecturas": [
                        {
                            "_id": "0",
                            "temperatura": null,
                            "elevacion": null,
                            "conductividad": null,
                            "conductividad_e": null,
                            "resistividad": null,
                            "salinidad": null,
                            "solidos_disueltos": null,
                            "densidad": null,
                            "presion_bar": null,
                            "ph": null,
                            "phmv": null,
                            "orp": null,
                            "oxigeno_dis": null,
                            "saturacion_ox": null,
                            "turbiedad": null,
                            "presion_par_ox": null,
                            "solidos_susp": null,
                            "volt_ext": null,
                            "cap_bateria": null,
                            "caudal": null,
                            "volumen": null,
                            "fechalec": "null",
                            "fechalectura": "2019-01-01T00:00:00.000Z",
                            "estatus": "No hay Datos",
                            "senal": null,
                            "temp_equipo": null,
                            "bateria": null
                        }
                    ]
                },
                {
                    "ultimalectura": [
                        {
                            "_id": "0",
                            "temperatura": null,
                            "elevacion": null,
                            "conductividad": null,
                            "conductividad_e": null,
                            "resistividad": null,
                            "salinidad": null,
                            "solidos_disueltos": null,
                            "densidad": null,
                            "presion_bar": null,
                            "ph": null,
                            "phmv": null,
                            "orp": null,
                            "oxigeno_dis": null,
                            "saturacion_ox": null,
                            "turbiedad": null,
                            "presion_par_ox": null,
                            "solidos_susp": null,
                            "volt_ext": null,
                            "cap_bateria": null,
                            "caudal": null,
                            "volumen": null,
                            "fechalec": "null",
                            "fechalectura": "2019-01-01T00:00:00.000Z",
                            "estatus": "No hay Datos",
                            "senal": null,
                            "temp_equipo": null,
                            "bateria": null
                        }
                    ]
                },
                {
                    "volmes": 0
                },
                {
                    "volsem": 0
                },
                {
                    "voldia": 0
                },
                {
                    "estatus": "Actualizando"
                }],
                contador:1,
                sitio:''      
            };
    }

    async componentDidMount(){
        var query = window.location.href;
        var sit=query.split("/");
        const res = await axios.get('https://api.instrutronica-iot.com/api/pruebas/overview6/'+sit[5]);
        this.setState({datos: res.data},()=>{this.setState({contador: this.state.contador++},()=>{this.render();}) });
        this.setState({sitio:sit[5]});

        this.interval =  setInterval(async() =>{
            var d = new Date();
            var n = d.getMinutes(); 
            var seg= d.getSeconds(); 
            if(localStorage.getItem('pruebas_app')==null){
                this.props.history.push("/");
            }
            //console.log(seg);
            if (n===1||n===16||n===31||n===46){
                if (seg===0){
                    const res = await axios.get('https://api.instrutronica-iot.com/api/pruebas/overview6/'+sit[5]);
                    this.setState({datos: res.data},()=>{this.setState({contador: this.state.contador++},()=>{this.render();}) });
                }
            }
        },1000);
    }
    
    componentWillUnmount() {
        clearInterval(this.interval);
       
    }

    render() {   
        //console.log(this.state.datos);     
            return (
                <div>
                    <Navigation/>
                  <Page  lecturas={this.state.datos} contador={this.state.contador}/>
                </div>
            )
    }
}
/*nombre={this.state.datos[0].nombresitio[0].nombre} mes={this.state.datos[2].mes} semana={this.state.datos[3].semana}  lecturas={this.state.datos[1].lecturas} ultimalectura={this.state.ultimalectura} */
export default withRouter(Dashboard)
